import { observer } from 'mobx-react';
import React from 'react';

import { FilteredProductList } from '../../../../Components/ProductFilters/FilteredProductList';
import { favourites } from '../../Favourites';
import { FavouriteProductsEmpty } from './FavouriteProductsEmpty';
import { FavouriteProductsListProps } from './FavouriteProductsListProps.csharp';

export const FavouriteProductsList = observer((props: FavouriteProductsListProps) => {
    const favouritesProducts = favourites.items?.favouriteProductCodes || props.favouritesViewModel?.favouriteProductCodes;

    return favouritesProducts?.length > 0 ? (
        <div className="FavouritesPage__List">
            <FilteredProductList {...props.filteredProductListProps} allowedProducts={favouritesProducts} />
        </div>
    ) : (
        <FavouriteProductsEmpty searchUrl={props.searchUrl} />
    );
});
